// extracted by mini-css-extract-plugin
export default {"skeleton":"circle_skeleton__uFNOq","fadeIn":"circle_fadeIn__SK-u1"};